import {
    Box,
    Flex,
    Text,
    Input,
    Image,
    Badge,
    InputGroup,
    InputLeftElement,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    useDisclosure,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    PopoverCloseButton,
} from '@chakra-ui/react';
import MyDiv from './investmentDeclarationList.style'
import ArrowIcon from "../../../../assets/images/ActionArrow.svg";
import FilterIcon from '../../../../assets/images/Filter.svg';
import SortIcon from '../../../../assets/images/SortIcon.svg';
import { Search2Icon } from '@chakra-ui/icons';
import { useState } from 'react';
import { FilterPopover } from '../../../../components';
import { useNavigate } from 'react-router-dom';
import * as routesNames from '../../../../constants/routes'

const sortOptions = [
    'Check-In Time (Earliest to Latest)',
    'Check-In Time (Latest to Earliest)',
    'Check-Out Time (Earliest to Latest)',
    'Check-Out Time (Latest to Earliest)',
    'Name (A–Z)',
    'Name (Z–A)',
];

const dummyData = [
    {
        id: 1,
        empId: "#1234564",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "New Tax Regime",
        hrReview: "Approved ",
        monthlyTax: "₹2342",
    },
    {
        id: 2,
        empId: "#1234565",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "Old Tax Regime",
        hrReview: "Pending",
        monthlyTax: "₹2342",
    },
    {
        id: 3,
        empId: "#1234565",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "Old Tax Regime",
        hrReview: "Rejected",
        monthlyTax: "₹2342",
    },
    {
        id: 4,
        empId: "#1234565",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "Old Tax Regime",
        hrReview: "Rejected",
        monthlyTax: "₹2342",
    },
    {
        id: 5,
        empId: "#1234565",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "Old Tax Regime",
        hrReview: "Rejected",
        monthlyTax: "₹2342",
    },
    {
        id: 6,
        empId: "#1234565",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "Old Tax Regime",
        hrReview: "Rejected",
        monthlyTax: "₹2342",
    },
    {
        id: 7,
        empId: "#1234565",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "Old Tax Regime",
        hrReview: "Rejected",
        monthlyTax: "₹2342",
    },
    {
        id: 8,
        empId: "#1234565",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "Old Tax Regime",
        hrReview: "Rejected",
        monthlyTax: "₹2342",
    },
    {
        id: 9,
        empId: "#1234565",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "Old Tax Regime",
        hrReview: "Rejected",
        monthlyTax: "₹2342",
    },
    {
        id: 10,
        empId: "#1234565",
        name: "Full Name",
        payrollCompany: "Payroll Company",
        branch: "Branch",
        grossAnnualSalary: "₹12345",
        netAnnualSalary: "₹12342",
        netDeductions: "₹12342",
        taxRegime: "Old Tax Regime",
        hrReview: "Rejected",
        monthlyTax: "₹2342",
    },
    // Add more objects as needed
];

const InvestmentDeclarationList = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selected, setSelected] = useState<string>(sortOptions[0]);
    const navigate = useNavigate();
    const handleSelect = (option: string) => {
        setSelected(option);
        onClose();
    };

    const handleClick = (emp: any) => {
        navigate(routesNames.INVESTMENTDECLARATIONDETAIL, { state: { employee: emp } });
    }
    return (
        <MyDiv>
            <Box>
                <Flex className="page_heading flex_header">
                    <Text className="font-poppins text_medium text_lg">Investment Declaration List</Text>
                    <Flex className="filter_section">
                        <InputGroup width="250px" height="25px">
                            <InputLeftElement pointerEvents="none">
                                <Search2Icon color="rgba(102, 112, 133, 1)" />
                            </InputLeftElement>
                            <Input type="text" className="font-poppins text_regular text_md" placeholder="Search Employee by name...." />
                        </InputGroup>

                        <Popover placement="bottom-end" closeOnBlur>
                            <PopoverTrigger>
                                <Image src={FilterIcon} alt="Filter" className="icon_btn" />
                            </PopoverTrigger>
                            <FilterPopover  filter={{filterOptions:{"Status": [{ id: 1, name: 'Approved' }, { id: 2, name: 'Rejected' }, { id: 3, name: 'Pending' }]}}}
                                onApplyFilter={(filter)=>console.log(filter)}/>
                        </Popover>

                        <Popover placement="bottom-end" closeOnBlur>
                            <PopoverTrigger>
                                <Image src={SortIcon} alt="Sort" className="icon_btn" />
                            </PopoverTrigger>
                            <PopoverContent w="270px" borderRadius="10px" boxShadow="md" textAlign={'center'}>
                                <Box px={4} py={2} borderBottom="1px solid #eee">
                                    <Text className='font-poppins text_sm text_medium' textAlign="center" color={"#00000080"}>Sort By</Text>
                                    <PopoverCloseButton top="8px" right="12px" />
                                </Box>
                                <PopoverBody p={0}>
                                    {sortOptions.map((option) => (
                                        <Box
                                            key={option}
                                            px={4}
                                            py={2}
                                            cursor="pointer"
                                            bg={selected === option ? '#EBEBEB' : 'white'}
                                            _hover={{ bg: '#EBEBEB' }}
                                            onClick={() => handleSelect(option)}
                                        >
                                            <Text className='font-poppins font_dark' fontSize="14px" fontWeight={selected === option ? '500px' : '500px'}>{option}</Text>
                                        </Box>
                                    ))}
                                </PopoverBody>
                            </PopoverContent>
                        </Popover>
                    </Flex>
                </Flex>
                {dummyData.length > 0 ? (
                    <TableContainer mt={4} borderRadius="12px" boxShadow="sm" bg="white">
                        <Table variant='striped'>
                            <Thead bg="#F9FAFB">
                                <Tr>
                                    <Th className='font-poppins text_sm text_medium'>S. No</Th>
                                    <Th className='font-poppins text_sm text_medium'>Emp ID</Th>
                                    <Th className='font-poppins text_sm text_medium'>Name</Th>
                                    <Th className='font-poppins text_sm text_medium'>Payroll Company</Th>
                                    <Th className='font-poppins text_sm text_medium'>Branch</Th>
                                    <Th className='font-poppins text_sm text_medium'>Gross Annual Salary</Th>
                                    <Th className='font-poppins text_sm text_medium'>Net Annual Salary</Th>
                                    <Th className='font-poppins text_sm text_medium'>Net Deductions</Th>
                                    <Th className='font-poppins text_sm text_medium'>Tax Regime</Th>
                                    <Th className='font-poppins text_sm text_medium'>HR Review</Th>
                                    <Th className='font-poppins text_sm text_medium'>Monthly Tax</Th>
                                    <Th className='font-poppins text_sm text_medium'>Action</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {dummyData.map((emp, index) => (
                                    <Tr key={emp.id}>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>{emp.id}</Td>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>
                                            <Badge variant="subtle" className="empId font-poppins text_sm text_medium" cursor="pointer" onClick={() => handleClick(emp)}>{emp.empId}</Badge>
                                        </Td>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>{emp.name}</Td>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>{emp.payrollCompany}</Td>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>{emp.branch}</Td>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>{emp.grossAnnualSalary}</Td>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>{emp.netAnnualSalary}</Td>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>{emp.netDeductions}</Td>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>{emp.taxRegime}</Td>
                                        <Td textAlign='center'>
                                            <Badge
                                                backgroundColor={emp.hrReview === 'Approved ' ? '#E5F2E5' : emp.hrReview === 'Rejected' ? '#FF00001A' : '#FFFF001A'}
                                                color={emp.hrReview === 'Approved ' ? '#008000' : emp.hrReview === 'Rejected' ? '#FF0000' : '#FFA500'}
                                                px={3}
                                                py={1}
                                                borderRadius="6px">
                                                <Text className='font-poppins text_regular text_sm'>{emp.hrReview}</Text>
                                            </Badge>
                                        </Td>
                                        <Td textAlign='center' className='font-poppins text_regular text_sm'>{emp.monthlyTax}</Td>
                                        <Td textAlign='center'>
                                            <Image src={ArrowIcon} alt="Action" cursor="pointer" onClick={() => handleClick(emp)} />
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Box
                        mt={6}
                        p={8}
                        textAlign="center"
                        color="gray.500"
                        className='font-poppins text_regular text_sm'
                    >
                        No Data Found
                    </Box>
                )}

            </Box>

        </MyDiv>
    )
}

export default InvestmentDeclarationList;
